import React from 'react';
import gql from 'graphql-tag';
import get from 'lodash.get';
import { Query, QueryResult } from 'react-apollo';
import { useHistory } from 'react-router-dom';
import {
  Subheader,
  Description,
  CheckIcon,
  FlexWrapper,
  Title,
  YellowButton
} from './styled-components';
import { medicationCheckmark as checkmark } from '../../../assets/icons';

const PATIENT_PACKAGES = gql`
  query patientPackages {
    patientPackages {
      id
      name
    }
  }
`;

type PatientPackagesResult = QueryResult<{
  patientPackages: Array<{
    id: string;
    name: string;
  }>;
}>;

const CyclePaymentSubstep = () => {
  const history = useHistory();

  return (
    <Query query={PATIENT_PACKAGES}>
      {({ data, error, loading }: PatientPackagesResult) => {
        if (loading || error || !data) {
          return null;
        }
        const patientPackages = get(data, 'patientPackages', []);
        const hasCycle = patientPackages.length > 0;

        return (
          <>
            <Title>Cycle payment {hasCycle && <CheckIcon src={checkmark} alt="check" />}</Title>
            <FlexWrapper>
              <div>
                <Subheader>When you’re ready to commit to cycling at Kindbody</Subheader>
                <Description>
                  Payment must be completed in full before your first cycle visit. If you have
                  insurance coverage, then you must have prior authorization completed.
                </Description>
              </div>
              {!hasCycle && (
                <YellowButton onClick={() => history.push('/cycle-payments')}>
                  Submit payment
                </YellowButton>
              )}
            </FlexWrapper>
          </>
        );
      }}
    </Query>
  );
};

export default CyclePaymentSubstep;
